import {
  getTrustedActiveSummaryState,
  hasTrustedFinalSummaryProvenance,
} from "./postSessionProvenance";
import {
  resolveRecordSummaryForActiveSession,
  withSessionScope,
} from "./sessionScope";

export function resolveRecordSummaryForView(record = {}, messages = []) {
  if (hasTrustedFinalSummaryProvenance(record)) {
    return withSessionScope(record.sessionSummary, record.id);
  }
  const activeSummaryState = getTrustedActiveSummaryState(record);
  if (activeSummaryState.snapshotValid) {
    return withSessionScope(record.sessionSummary, record.id);
  }
  const hasProtectedActiveProjection = Boolean(
    record?.sessionComplete !== true &&
    (
      record?.sessionSummary?.generationStatus === "active_validated" ||
      record?.postSessionContinuation?.activeSummary?.accepted
    )
  );
  return resolveRecordSummaryForActiveSession({
    record: hasProtectedActiveProjection
      ? { ...record, sessionSummary: null }
      : record,
    sessionId: record?.id,
    messages,
  });
}
